"use client";

import { showLoader } from "action/loader/showLoader";
import { RootState } from "interfaces/generics.type";
import SafeLink from "modules/components/SafeLink";
import { useRouter } from "next/router";
import { cloneElement } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isTires } from "util/category/is-tires";
import { isWheels } from "util/category/is-wheels";
import { toLowerCase } from "util/lodash/toLowerCase";
import getCustomSizeQuery from "util/url/getCustomSizeQuery";
import { getCleanCategoryObj } from "../../util/helper/getCleanCategoryObj";
import withErrorHandler from "../design-system/withErrorHandler";

function CategoryViewItem(props: any) {
  const {
    categoryObj = {}, style, className, passOnClick, defaultFilters = {}, resetAllFilters = true, url,
    skipApi,
  } = props;
  const cleanCategoryObj = getCleanCategoryObj(categoryObj);
  const router = useRouter();
  const dispatch = useDispatch();

  const currentSelectedVehicle = useSelector((state: RootState) => state.garage.selectedVehicle);

  const selectedVehicle = cleanCategoryObj.tier0 !== "Tools & Equipment" ? currentSelectedVehicle : undefined;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { pathname, ...presentQueryParams } = router.query;
  const buildQueryParams = resetAllFilters ? defaultFilters : presentQueryParams;
  const customSizes = getCustomSizeQuery();
  if (Object.keys(customSizes).length > 0 && isTires(toLowerCase(cleanCategoryObj.tier1))) {
    Object.assign(buildQueryParams, customSizes?.customTireSize);
  } else if (Object.keys(customSizes).length > 0 && isWheels(toLowerCase(cleanCategoryObj.tier1))) { // check added to remove other invalid custom sizes
    Object.assign(buildQueryParams, customSizes?.customWheelSize);
  }
  function onClick() {
    dispatch(showLoader());
    import("./handler/CategoryViewItemhandler")
      .then((module) => {
        module.categoryViewItemhandler(router, cleanCategoryObj, selectedVehicle, props.onClick, { buildQueryParams, url });
      });
  }

  const passingpProps = {
    style,
    className,
    onClick: !passOnClick ? onClick : undefined,
  };

  if (skipApi) {
    return (
      <SafeLink href={url}>
        {props.children}
      </SafeLink>
    );
  }

  if (!passOnClick) {
    return (
      <div
        {...passingpProps}
      >
        {cloneElement(props.children)}
      </div>
    );
  }
  return cloneElement(props.children, { onClick: passOnClick ? onClick : undefined });
}

export default withErrorHandler(CategoryViewItem);
